import { defineMessages } from 'react-intl';

export const bonusPointsMessages = defineMessages({
  PAYBACK: {
    id: 'bonusPoints.payback.text',
    defaultMessage: '{value} PAYBACK {value, plural, one {Punkt} other {Punkte}}',
  },
  JOE: {
    id: 'bonusPoints.joe.text',
    defaultMessage: '{value} {value, plural, one {Ö} other {Ös}} sammeln',
  },
});
